import { ComponentType, useEffect } from 'react'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { useAppDispatch } from 'app/hooks'
import { logout } from 'app/reducer/authSlice'

const withStudentAuth = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  const WithStudentAuth = (props: P) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const token = Cookies.get('token')

    useEffect(() => {
      if (!token) {
        navigate('/')
        dispatch(logout())
        return
      }

      const decodedToken: any = jwtDecode(token)
      if (decodedToken?.exp * 1000 < Date.now()) {
        navigate('/')
        dispatch(logout())
      }
    }, [token, navigate, dispatch])

    return <WrappedComponent {...props} />
  }

  WithStudentAuth.displayName = `withStudentAuth(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return WithStudentAuth
}

export default withStudentAuth
